import React from 'react'
import { Paper, Typography, Button, CircularProgress, Box } from '@mui/material'

const PRICE = 7

function MaintenancePlanInfo({ onSubmit, saving }) {
  return (
    <Box>
      <Typography variant='h4'>Kiinteistön huoltosuunnitelma</Typography>
      <Paper sx={{ m: 2.5, p: 2.5 }}>
        <Typography variant='body1' sx={{ mb: 3 }} component='p'>
          Huoltosuunnitelma kokoaa kiinteistösi toistuvat huoltotehtävät yhteen
          näkymään: tarkastukset, vuosihuollot, suodattimien vaihdot ja muut
          säännöllisesti tehtävät toimenpiteet. Näet yhdellä silmäyksellä mitä
          on tulossa, mitä on myöhässä ja mitä on hoidettu aikataulussa.
        </Typography>
        <Typography variant='body1' sx={{ mb: 3 }} component='p'>
          Voit luoda kullekin tehtävälle oman aikataulun (kerran vuodessa,
          kuukausittain, joka kolmas kuukausi, …) ja kohdistaa sen tiettyyn
          kohteeseen tai tilaan. Suunnitelmaa täydentävät huoltohenkilöstön
          merkinnät ja kuitti­liitteet, jotta historia säilyy yhdessä paikassa.
        </Typography>
        <Typography variant='body1' sx={{ mb: 3 }} component='p'>
          Huoltosuunnitelma toimii yhdessä Kiinteistöhuollon tikettien kanssa:
          kun suunnitelman tehtävä siirtyy työn alle, siitä syntyy tiketti
          jonka tila etenee samalla tavalla kuin asiakkaiden ilmoittamat viat.
          Voit myös kytkeä suunnitelman päälle erikseen, jos haluat aloittaa
          vain ennakoivasta huollosta.
        </Typography>
        <Typography variant='body1' sx={{ mb: 4 }} component='p'>
          Voit ottaa huoltosuunnitelman käyttöön tästä. Ensimmäiset kaksi
          viikkoa ovat ilmainen testijakso. Tämän jälkeen ominaisuus maksaa
          {' '}{PRICE}€/kk. Voit lopettaa palvelun milloin tahansa.
        </Typography>
        <Button
          disabled={saving}
          variant='contained'
          color='primary'
          onClick={() => onSubmit(PRICE)}
        >
          {saving ? <CircularProgress size={25} color='info' /> : 'Ota käyttöön'}
        </Button>
      </Paper>
    </Box>
  )
}

export default MaintenancePlanInfo
